/*
 * Copyright (c) Dito Technologies
 */

import React from "react";
import ContentWrapper from "ui/common/ContentWrapper";
import Header1 from "ui/kit/typography/Header1";
import {QueryRenderer} from "react-relay";
import environment from "constants/environment";
import query from "ui/feature/piece-settings/PieceSettingsQuery"
import {useParams} from "react-router-dom";
import ErrorSection from "ui/common/ErrorSection";
import LoadingSection from "ui/common/LoadingSection";
import PieceSettingsBody from "ui/feature/piece-settings/PieceSettingsBody";
import {PieceSettingsQuery} from "ui/feature/piece-settings/__generated__/PieceSettingsQuery.graphql";

const PieceSettings: React.FC = () => {
    const params = useParams();
    const pieceId = params.piece_id || "";
    return (
        <ContentWrapper>
            <Header1>Settings</Header1>
            <QueryRenderer<PieceSettingsQuery>
                environment={environment}
                query={query}
                variables={{piece_id: pieceId}}
                render={({error, props}) => {
                    if (error) {
                        return <ErrorSection/>
                    } else if (props) {
                        return <PieceSettingsBody viewer={props.music_viewer} piece={props.music_viewer.piece}/>;
                    } else {
                        return <LoadingSection/>;
                    }
                }}/>
        </ContentWrapper>
    )
}

export default PieceSettings;